// extracted by mini-css-extract-plugin
export var avatarContainer = "_3z-0";
export var gray = "_3z-f";
export var green = "_3z-c";
export var icon = "_3z-9";
export var image = "_3z-1";
export var lg = "_3z-6";
export var md = "_3z-5";
export var presenceDot = "_3z-b";
export var red = "_3z-d";
export var sm = "_3z-4";
export var status = "_3z-a";
export var xl = "_3z-7";
export var xs = "_3z-3";
export var xxl = "_3z-8";
export var xxs = "_3z-2";
export var yellow = "_3z-e";